import React from "react"
import DOMPurify from "dompurify"
import { Modal, Spin, Typography } from "@mimber/ui-web"
import { useCommunicationTemplate } from "@mimber/client/mimber-organization"
import type { CommunicationTemplatePreviewModalProps } from "./CommunicationTemplatePreviewModal.types"

const { Text } = Typography

export const CommunicationTemplatePreviewModal: React.FunctionComponent<
  CommunicationTemplatePreviewModalProps
> = ({ templateUuid, ...modalProps }) => {
  const { data, isLoading } = useCommunicationTemplate(templateUuid)

  const template = data?.data

  return (
    <Modal
      footer={null}
      title={template?.name ?? "Template Preview"}
      width={720}
      {...modalProps}
    >
      {() =>
        isLoading ? (
          <div
            style={{ textAlign: "center", padding: 48 }}
            data-testid="template-preview-loading"
          >
            <Spin size="large" />
          </div>
        ) : template ? (
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(template.content),
            }}
            data-testid="template-preview-content"
          />
        ) : (
          <Text type="secondary">Template not found</Text>
        )
      }
    </Modal>
  )
}
